import { ReactComponent as Svg } from "./close.svg";

export const CloseSvg = () => {
  return <Svg />;
};
